import http from './reddit'
// openManagement
export default {
  // 期数 select 值
  select: (gameid, pid = 0) => http.Get(`${http.url.six}/lotresmrk/${gameid}/${pid}`),
  // 期数列表
  table: (gameid, page = 500) => http.Get(`${http.url.hfl}/ltlt/${gameid}/${page}`),
  // 设定开奖号码
  settingLotteryBall: (gameid, data) => http.Post(`${http.url.six}/settle/${gameid}`, data),
  // 结算
  settlement: (gameid, data) => http.Post(`${http.url.six}/ptmark/${gameid}`, data),
  // 重新结算
  resetSettlement: (gameid, data) => http.Post(`${http.url.six}/resett/${gameid}`, data),
  // 反结算
  backSettlement: (gameid, data) => http.Post(`${http.url.six}/zeroing/${gameid}`, data),
}